'use client';

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as React from 'react';

import { usePortalContainerRef } from '@/lib/context/portal-container/use-portal-container-ref';
import { tv } from '@/utils/styles';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => {
  // If the hovercard is rendered within a portal, mount it inside
  const portalContainer = usePortalContainerRef();

  const { content } = styles();
  return (
    <HoverCardPrimitive.Portal container={portalContainer?.current}>
      <HoverCardPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={content({ className })}
        onClick={(event) => event.stopPropagation()}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
});
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

const styles = tv({
  slots: {
    content:
      'z-50 w-80 rounded-md border border-grey-200 bg-white text-text-primary shadow-lg outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
  },
});

export { HoverCard, HoverCardContent, HoverCardTrigger };
